import React from 'react';
import styled from 'styled-components';
import WindowControls from '../Common/WindowControls';

const AuthContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.dark.bg};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows.xl};
`;

const TitleBar = styled.div`
  height: 32px;
  background: ${({ theme }) => theme.colors.dark.surface};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  -webkit-app-region: drag;
  border-bottom: 1px solid ${({ theme }) => theme.colors.dark.border};
`;

const ContentArea = styled.div`
  flex: 1;
  display: flex;
`;

const AuthLayout = ({ children }) => {
  return (
    <AuthContainer>
      <TitleBar>
        <WindowControls />
      </TitleBar>
      <ContentArea>
        {children}
      </ContentArea>
    </AuthContainer>
  );
};

export default AuthLayout;
